import {DataAttrFilterRule, FilterSource} from "./groupsListFilter";

export default class FilterButtonDataSource extends FilterSource {
    element
    fieldName
    constructor(element, fieldName) {
        super();
        this.element = element;
        this.fieldName = fieldName;
    }

    getActiveRules() {
        const rules = this.element.data(this.fieldName)
        if (!rules) {
            return []
        }
        return rules.flatMap((rule) => {
            if (typeof rule === 'string') {
                rule = {
                    method: 'filter',
                    tags: [rule],
                }
            }
            const groupOptions = {
                op: rule.method
            }
            return rule.tags.map((tag) => {
                return new DataAttrFilterRule($.extend({
                    name: 'tags',
                    value: tag,
                    op: 'filter',
                }, groupOptions))
            })
        })
    }
}
